import { render, staticRenderFns } from "./ApplicantMessage.vue?vue&type=template&id=a511e00c"
import script from "./ApplicantMessage.vue?vue&type=script&lang=js"
export * from "./ApplicantMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports